export enum TimerStatus {
  Idle = "idle",
  Running = "running",
  Paused = "paused",
}
